import MUIAvatar, { AvatarProps } from "@mui/material/Avatar";
import classNames from "classnames";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { LG, MD, SM } from "../../types";
import { styles } from "./styles";

export interface ICompanyAvatarProps extends AvatarProps {
  size?: SM | MD | LG;
}

const useStyles = makeStyles<Theme, ICompanyAvatarProps>(styles);

const CompanyAvatar = (props: ICompanyAvatarProps) => {
  const { children, size, ...rest } = props;
  const classes = useStyles(props);

  const rootClassName = classNames(classes.root, size && classes[size]);

  return (
    <MUIAvatar className={rootClassName} {...rest}>
      <div />
      {children}
    </MUIAvatar>
  );
};

export default CompanyAvatar;
